"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.languageAbandoned = void 0;
var analytics_layer_1 = require("@pmi/analytics-layer");
var utils_1 = require("../utils");
var languageAbandoned = function (event) {
    var eventData = {
        event: analytics_layer_1.LanguageEventNames.LanguageAbandoned,
        eventInfo: analytics_layer_1.LanguageEventNames.LanguageAbandoned,
        language: {
            languageupdate: event.eventData.language.languageupdate,
        },
    };
    return (0, utils_1.checkDataLayerValueEmpty)(eventData);
};
exports.languageAbandoned = languageAbandoned;
